export const RECENT_INVITE_DAYS = 3;

function shortDate(iso: string): string {
  const d = new Date(iso);
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    ...(sameYear ? {} : { year: 'numeric' }),
  });
}

export function inviteSentLabel(sentAt?: string | null, sentBy?: string | null): string | null {
  if (!sentAt) return null;
  return `Last sent ${shortDate(sentAt)}${sentBy ? ` by ${sentBy}` : ''}`;
}

export function sentRecently(sentAt?: string | null, now = Date.now()): boolean {
  if (!sentAt) return false;
  return now - new Date(sentAt).getTime() < RECENT_INVITE_DAYS * 24 * 60 * 60 * 1000;
}

// True when it's fine to send: nothing went out in the last few days, or the
// sender confirmed they want another.
export function confirmResendInvite(
  name: string,
  sentAt?: string | null,
  sentBy?: string | null,
): boolean {
  if (!sentRecently(sentAt)) return true;
  return window.confirm(
    `${name} was sent an invite on ${shortDate(sentAt!)}${sentBy ? ` by ${sentBy}` : ''}. Send another one?`,
  );
}
